export default __webpack_public_path__ + "static/media/calendar.525b5a99.svg";